import ApiService from '@/services/api.service'

const ModifierService = {
    getAll(parameter){
        const requestData = {
            method: 'get',
            url: "/MessageHistories/",
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,
            }
          }
          return ApiService.customRequest(requestData);
    },

    getAllHistories(parameter) {
            const params = {
                SearchCriteria: parameter.SearchCriteria,
                PageSize: parameter.PageSize,
                PageNumber: parameter.PageNumber,
                PatientCodeList: parameter.PatientCodeList,
                RecipientTypeList: parameter.RecipientTypeList,
                ModuleList: parameter.ModuleList,
                ActionList: parameter.ActionList,
                NotificationTypeList: parameter.NotificationTypeList,
                StatusList: parameter.StatusList,
                DateFrom:parameter.DateFrom,
                DateTo:parameter.DateTo,
            };
            return ApiService.getWithArray('/MessageHistories/Notices/', params);
        },


    Get(Id){
        return ApiService.get(`/MessageHistories/${Id}`);
    },
  }



  export default ModifierService;
